// JsonService.js
export default class JsonService {
  static async fetchJson({ url, signal, cache = 'no-store' }) {
    const res = await fetch(url, { signal, cache });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    return res.json();
  }

  static loadToState({ url, setData, setError, cache = 'no-store' }) {
    const ctrl = new AbortController();
    JsonService.fetchJson({ url, signal: ctrl.signal, cache })
      .then(setData)
      .catch((e) => {
        if (e.name !== 'AbortError') setError(e);
      });
    return () => ctrl.abort();
  }
}
